export default __webpack_public_path__ + "static/media/75.4ff4b145.jpeg";